import { useState, useEffect } from "react";
import { Box } from "@mui/material";
import WifiOffIcon from '@mui/icons-material/WifiOff';

const NetworkStatus = () => {
	const [isOnline, setIsOnline] = useState(navigator.onLine);

	useEffect(() => {
		const handleOnline = () => setIsOnline(true);
		const handleOffline = () => setIsOnline(false);

		window.addEventListener("online", handleOnline);
		window.addEventListener("offline", handleOffline);

		// Cleanup event listeners on component unmount
		return () => {
			window.removeEventListener("online", handleOnline);
			window.removeEventListener("offline", handleOffline);
		};
	}, []);

	const [slowConnection, setSlowConnection] = useState(false);

	useEffect(() => {
		interface NavigatorWithConnection {
			connection: {
				effectiveType: string;
			};
			mozConnection: {
				effectiveType: string;
			};
			webkitConnection: {
				effectiveType: string;
			};
		}

		const connection = (navigator as unknown as NavigatorWithConnection).connection || (navigator as unknown as NavigatorWithConnection).mozConnection || (navigator as unknown as NavigatorWithConnection).webkitConnection;

		if (connection && (connection.effectiveType === '2g' || connection.effectiveType === 'slow-2g')) {
			console.log('koneksi lambat');
			setSlowConnection(true);
		} else {
			console.log('koneksi cepat');
			setSlowConnection(false);
		}
	}, []);

	return (
		<>
			{!isOnline && (
				<Box
					style={{
						padding: "10px",
						backgroundColor: "red",
						color: "white",
						display: "flex",
						alignItems: "center",
						borderRadius: "5px",
						opacity: 0.95,

						position: "fixed",
						top: 16,
						width: "200px",
						zIndex: 999999999999999,
					}}>
					<WifiOffIcon style={{ marginRight: 8 }} />
					You are offline
				</Box>
			)}
			{
				slowConnection && (
					<Box
						style={{
							padding: "10px",
							backgroundColor: "orange",
							color: "white",
							display: "flex",
							alignItems: "center",
							borderRadius: "5px",
							opacity: 0.95,
							position: "fixed",
							top: 16,
							width: "fit-content",
						}}>
						<WifiOffIcon style={{ marginRight: 8 }} />
						Koneksi internet kamu lambat.
					</Box>
				)
			}
		</>
	);
};

export default NetworkStatus;
